// @ts-nocheck
import React, { useEffect } from 'react';
import moment from 'moment';
import 'moment-timezone';
import formatAtheneumContact from "./helpers/initializeHelpers/formatAtheneumContact";
import getZoomNumber from "./helpers/initializeHelpers/getZoomNumber";
import expertEmailTemplate from "./helpers/initializeHelpers/emailTemplates/expertEmailTemplate"; //importing pages

import Overview from "./pages/Overview";
import { Scheduling } from "./pages/Scheduling";
import { SendInviteClient } from "./pages/SendInviteClient";
import { SendInviteExpert } from "./pages/SendInviteExpert";
import { QuickEdit } from "./pages/QuickEdit";
import { CreateZoom } from "./pages/CreateZoom"; //importing Components

import ZoomContainer from "./components/ZoomContainer";
import Submit from "./components/Submit";
import AvailabilityForm from "./pages/AvailabilityForm";
import getMcKinseyMeeting from "./api/getMcKinseyMeeting";
import RenderPhonenumbers from "./components/RenderPhoneNumber";
import { get } from 'lodash';
import { getTimezoneName, sendMetric } from '@atheneum/api/dist/lib';
import { generateLocationLabel } from "./helpers/InviteHelpers";
import Spinner from "./components/spinner";
import InfoBox from "./components/InfoBox"; // Helper methods

import { getCountryId, getInitialStates, formatZoomMeetingId, formatInvitationSubject } from "./helpers"; // APIs

import { getAddressById, projectApi, scheduleApi, teamApi } from '@atheneum/api';
import { translate, getEmployeeSubmitted, getTakenExpertSlots, getEmailTemplate, getExpert, getClientContact, getProjectClients } from "./api"; // Global States for faster scheduling

import { useStore } from "./contexts/store";

const FasterScheduling = ({
  availabilityStore,
  sendToCalendarService,
  eplModel,
  handleClose,
  growlStore,
  onDeleteTimeslot,
  project,
  multipleExperts,
  showAddExpert,
  multiAction // projectStore

}) => {
  // global state initial setup
  const {
    state,
    dispatch
  } = useStore();
  const {
    capiProjectType
  } = project;
  const {
    currentPath,
    readOnly,
    updated,
    firstMatch,
    selectedDate,
    schedule,
    renderSpinner,
    selectedLanguage,
    templateLanguages
  } = state; // Things to do when availability store is done loading

  useEffect(() => {
    if (!availabilityStore.isLoading && !updated) {
      init();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [availabilityStore.isLoading, updated]);

  const init = async () => {
    if (!availabilityStore.epl.expert.address.timezoneId) {
      sendMetric('scheduling.ExpertMissingTimezone', 'scheduling', {
        status: 'warning'
      });
      growlStore.showWarning(`Expert timezone is defaulted to:  <strong>${moment.tz.guess()}<strong/> <br/> <br/> CLICK here to update expert profile`, `Expert profile is missing timezone.`, () => window.location.href = `${window.location.origin}/expert/${availabilityStore.epl.expert.id}`);
    }

    const {
      newStates,
      updatedSchedule,
      initFirstMatch
    } = getInitialStates(availabilityStore, firstMatch, multipleExperts, eplModel, showAddExpert, multiAction);
    const stateToUpdate = {
      updated: true,
      renderSpinner: true
    }; // TODO: rename variables to represent what it is

    const {
      result,
      onSelectDate: onSelectDateUpdate
    } = updatedSchedule;

    if (typeof onSelectDateUpdate !== 'string') {
      stateToUpdate.selectedDate = onSelectDateUpdate;
    }

    if (initFirstMatch.time > 0) {
      stateToUpdate.firstMatch = initFirstMatch.time;
    }

    if (typeof result !== 'string') {
      dispatch({
        type: 'SETSCHEDULE',
        payload: {
          schedule: result
        }
      }); // dayToRender is the date that is displayed and used to schedule
      // default to the selectedDate, other wise it should be the be the first scheduled timeslot's start time
      // firstMatch is a timestamp that indicates the first overlapping availability between client and expert

      stateToUpdate.dayToRender = moment(selectedDate);

      if (!!result.timeslots.length && result.timeslots[0].time.start > new Date().getTime()) {
        stateToUpdate.dayToRender = moment(result.timeslots[0].time.start);
      }

      if (firstMatch > 0) {
        stateToUpdate.dayToRender = moment(firstMatch);
      }
    } // In case day to render is in the past, set today


    if (moment(stateToUpdate.dayToRender).isBefore(moment())) {
      stateToUpdate.dayToRender = moment();
    }

    dispatch({
      type: 'UPDATE',
      payload: { ...newStates,
        ...stateToUpdate
      }
    }); // Async actions

    try {
      const employeeSubmitted = await getEmployeeSubmitted(availabilityStore);
      const {
        activeTeams,
        selectedTeam
      } = await getTeams();
      const {
        allZoomNumbers,
        zoomNum
      } = await getZoomNums();
      const takenExpertSlots = await getTakenExpertSlots(availabilityStore);
      const clientContactOptions = await getClientContact(availabilityStore);
      const projectClients = await getProjectClients(availabilityStore.epl.projectId); // TODO: have more clear defined value return by function, so there's no ambiguity for what to update

      let moreStateToUpdate = {};

      if (availabilityStore.schedule) {
        moreStateToUpdate = await getClientInfo(projectClients);
        const expertInfo = await getExpertInfo();
        moreStateToUpdate = {
          anonymizeClients: availabilityStore.schedule.anonymizeClients,
          anonymizeExpert: availabilityStore.schedule.anonymizeExpert,
          ...moreStateToUpdate,
          ...expertInfo
        };
      } else {
        moreStateToUpdate = await getDataWhenTheresNoSchedule();
      }

      if (availabilityStore.persistedScheduleInfo) {
        const zoomData = await projectApi.getZoomMeetings(availabilityStore.epl.projectId, availabilityStore.persistedScheduleInfo.startTime);
        moreStateToUpdate = { ...moreStateToUpdate,
          existingZoomMeeting: zoomData.filter(d => d.expertNames !== availabilityStore.epl.expert.fullName),
          connectedZoomMeeting: zoomData
        };
      }

      const updatedState = {
        employeeSubmitted,
        activeTeams,
        selectedTeam,
        allZoomNumbers,
        zoomNum,
        takenExpertSlots,
        clientContactOptions,
        ...moreStateToUpdate
      };
      dispatch({
        type: 'UPDATE',
        payload: updatedState
      });
    } catch (error) {
      console.error(error); // Do we need this?

      sendMetric('Outlook.fail', 'expertEvent', {
        user: availabilityStore.userStore.user.id
      });
    }
  };

  const getTeams = async () => {
    var _availabilityStore$us, _availabilityStore$us2;

    const data = await teamApi.getActiveTeams();
    const activeTeams = [...data.slice().concat({
      id: -1,
      name: 'Kanban'
    }).sort((a, b) => a.name - b.name).map(team => ({
      value: team.id,
      label: team.name
    }))];
    let defaultTeamId = 44;

    if (window.location.origin.includes('localhost') || window.location.origin.includes('platform.training.atheneum-dev.com')) {
      defaultTeamId = -1;
    }

    if (window.location.origin === 'https://platform.atheneum-app.com' || window.location.origin === 'https://platform.integration.atheneum-dev.com' || window.location.origin.includes('dev3')) {
      defaultTeamId = 72;
    }

    const teamId = ((_availabilityStore$us = availabilityStore.userStore.user) === null || _availabilityStore$us === void 0 ? void 0 : (_availabilityStore$us2 = _availabilityStore$us.currentPosition) === null || _availabilityStore$us2 === void 0 ? void 0 : _availabilityStore$us2.teamId) || defaultTeamId;
    const myTeam = activeTeams.filter(team => team.value === teamId);
    return {
      activeTeams: activeTeams,
      selectedTeam: myTeam[0]
    };
  };

  const getZoomNums = async () => {
    const data = await scheduleApi.getZoomNumbers();
    const {
      countryId: clientCountryId
    } = await getAddressById(project.office.addressId);
    const clientId = getCountryId(data, clientCountryId);
    const expertId = getCountryId(data, availabilityStore.epl.expert.address.countryId);
    const getCountryNumberClient = data.filter(data => data.countryId === clientId);
    const getCountryNumberExpert = data.filter(data => data.countryId === expertId);
    return {
      allZoomNumbers: data,
      zoomNum: [...getCountryNumberExpert, ...getCountryNumberClient]
    };
  }; // TODO: rewrite this


  const getClientInfo = async projectClients => {
    const clientEvent = await scheduleApi.getClientEvent(availabilityStore.schedule.id);
    let html = document.createElement('html');
    html.innerHTML = clientEvent.body.content;

    if (!clientEvent.body.content.includes('"additional-text"')) {
      let paragraphs = html.getElementsByTagName('p');
      let p = paragraphs[1];

      if (clientEvent.body.content.includes('"screening"') || clientEvent.body.content.includes('"expert-pdf"')) {
        p.innerHTML = p.innerHTML + '<span id="additional-text" contenteditable="false">{{{additionalText}}}</span>';
      } else {
        p.innerHTML = p.innerHTML + '<span id="additional-text" contenteditable="false"></span>';
      }
    }

    if (clientEvent.body.content.includes('"expert-pdf"')) {
      let pdfDiv = html.querySelector('#expert-pdf');

      if (clientEvent.body.content.includes('"screening"')) {
        let screeningDiv = html.querySelector('#screening');
        screeningDiv.before(pdfDiv);
      } else if (clientEvent.body.content.includes('"signature"')) {
        let signatureDiv = html.querySelector('#signature');
        signatureDiv.before(pdfDiv);
      }
    }

    clientEvent.body.content = html.innerHTML;
    let dataToReturn = {};

    if (!!clientEvent && clientEvent.body) {
      clientEvent.body.content = clientEvent.body.content.replace(/\r\n/g, '');
      const replacedUrls = replaceEmailInfoWithPlaceholders(clientEvent.body.content, '#clientJoinUrls', 'CLIENT_JOIN_URLS');
      clientEvent.body.content = replaceEmailInfoWithPlaceholders(replacedUrls, '#clientNames', 'CLIENT_NAMES');
      const MC_KINSEY_PARENT_ACCOUNT_ID = 32;
      const mcKinseyMeeting = !!capiProjectType && ((await getMcKinseyMeeting(availabilityStore.epl.id, availabilityStore.epl.honorarium)) || project.parentAccountId === MC_KINSEY_PARENT_ACCOUNT_ID);

      if (!!mcKinseyMeeting) {
        dataToReturn = {
          // AP-3576
          mcKinseyMessage: mcKinseyMeeting.expertMessage,
          mcKinseyTemplates: mcKinseyMeeting.templates,
          selectedTemplate: mcKinseyMeeting.currentTemplate,
          templates: mcKinseyMeeting.templates,
          mcKinseyNumbers: mcKinseyMeeting.phoneNubers,
          meetingType: 'mcKinsey'
        };
      }

      if (clientEvent.body && clientEvent.body.content && !clientEvent.body.content.includes('https://atheneum-partners.zoom.us/')) {
        dataToReturn.meetingType = !!mcKinseyMeeting ? 'mcKinsey' : 'None';
      }

      const filterClientContacts = !!clientEvent.attendees && clientEvent.attendees.filter(client => {
        const findClient = projectClients.find(user => user.email === client.emailAddress.address);
        return findClient || client.emailAddress.address.includes('seed.') && client.emailAddress.address.includes('atheneum');
      }).map(x => ({
        fullName: x.emailAddress.name,
        email: x.emailAddress.address
      }));
      const AtheneumContacts = clientEvent.attendees.filter(client => {
        const findClient = projectClients.find(user => user.email === client.emailAddress.address);
        return !findClient && !client.emailAddress.address.includes('dev') && !client.emailAddress.address.includes('seed.');
      }).map(x => formatAtheneumContact(x));
      dataToReturn.additionalEmailsClient = AtheneumContacts;

      if (!!clientEvent.attendees) {
        dataToReturn.numberOfAddedClientEmail = filterClientContacts.length;
        dataToReturn.clientContacts = [...filterClientContacts];
        dataToReturn.numberOfAdditionalClientEmail = AtheneumContacts.length;
      }

      const employeePositionId = availabilityStore.userStore.user.currentPosition.employeePositionId;
      const userPosition = availabilityStore.staticData.names.employeePositions[employeePositionId] || '';
      const userPhones = availabilityStore.userStore.user.address.phones;
      const userPhoneNumbers = userPhones.map(phone => phone.phoneNum);
      const splitEmailBody = clientEvent.body.content.split('<p>');
      const emailBody = splitEmailBody.map(string => {
        if (string.includes('href="www.atheneum-partners.com">')) {
          return `
            ${availabilityStore.userStore.user.fullName}<br>
            ${userPosition}<br>
            ${availabilityStore.userStore.user.email}<br>
            ${userPhoneNumbers.join('<br>')}<br>
            <a href="www.atheneum-partners.com">www.atheneum-partners.com</a>
            </p>
            `;
        }

        return string;
      }).join('<p>'); // Default values for these three states

      dataToReturn.clientSubject = clientEvent.subject;
      dataToReturn.clientMessage = emailBody;
      dataToReturn.clientInvited = true;
      const expertPosition = get(availabilityStore.epl, 'relevantExperience.experience.position.name', '');
      const expertCompany = get(availabilityStore.epl, 'relevantExperience.experience.company.name', '');
      const expertLocation = get(availabilityStore.epl, 'relevantExperience.experience.location', '');
      const relevantSegment = get(availabilityStore.epl, 'segment.name', '');
      const expertInfo = availabilityStore.epl.nameDisclosed ? ` ${availabilityStore.epl.expert.title} ${availabilityStore.epl.expert.fullName || 'Expert'}, ${expertPosition}, ${expertCompany}, ${expertLocation} for Segment: ${relevantSegment}` : ` expert${expertLocation ? ' from ' + expertLocation : ''}, ${expertPosition}, ${expertCompany}, for Segment: ${relevantSegment}`;

      if (clientEvent.body.content.includes(availabilityStore.epl.expert.fullName) && !availabilityStore.epl.nameDisclosed) {
        const splitted = emailBody.split('<p>');
        const mapped = splitted.map(el => el.includes('I am pleased') ? `I am pleased to confirm the consultation call scheduled with ${expertInfo}</p>` : el);
        dataToReturn.clientSubject = 'Atheneum call';
        dataToReturn.clientMessage = mapped.join('<p>').replace('<p></p>', '');
      }

      if (!clientEvent.body.content.includes(availabilityStore.epl.expert.fullName) && availabilityStore.epl.nameDisclosed) {
        const splitted = emailBody.split('<p>');
        const mapped = splitted.map(el => el.includes('I am pleased') ? `I am pleased to confirm the consultation call scheduled with ${expertInfo}</p>` : el);
        dataToReturn.clientSubject = `Atheneum: ${availabilityStore.project.projectName} - ${availabilityStore.epl.segment.name} - ${availabilityStore.epl.expert.title} ${availabilityStore.epl.expert.fullName}`;
        dataToReturn.clientMessage = mapped.join('<p>').replace('<p></p>', '');
      }

      const location = clientEvent.location.displayName; // Default value for zoomLocationClient

      dataToReturn.zoomLocationClient = location;

      if (location.includes('{{{meetingId}}}')) {
        const zoomData = await scheduleApi.getZoomNumbers();
        const {
          countryId: clientCountryId
        } = await getAddressById(project.office.addressId);
        const clientId = getCountryId(zoomData, clientCountryId);
        const getCountryNumberClient = zoomData.filter(data => data.countryId === clientId);
        const resultClient = getZoomNumber(getCountryNumberClient[0]);
        const placeholder = '{{{meetingId}}}';
        dataToReturn.zoomLocationClient = `Conference call ${resultClient} // ${availabilityStore.schedule.zoomMeetingId ? formatZoomMeetingId(availabilityStore.schedule.zoomMeetingId) : placeholder}`;
      }

      return dataToReturn;
    }

    const zoomData = await scheduleApi.getZoomNumbers();
    const {
      countryId: clientCountryId
    } = await getAddressById(project.office.addressId);
    const clientId = getCountryId(zoomData, clientCountryId);
    const getCountryNumberClient = zoomData.filter(zoomData => zoomData.countryId === clientId);
    const resultClient = getZoomNumber(getCountryNumberClient[0]);
    const placeholder = '{{{meetingId}}}';
    return {
      zoomLocationClient: `Conference call ${resultClient} // ${availabilityStore.schedule.zoomMeetingId ? formatZoomMeetingId(availabilityStore.schedule.zoomMeetingId) : placeholder}`
    };
  }; // TODO: rewrite this


  const getExpertInfo = async () => {
    const expertEvent = await scheduleApi.getExpertEvent(availabilityStore.schedule.id);

    if (!!expertEvent && expertEvent.body) {
      expertEvent.body.content = replaceEmailInfoWithPlaceholders(expertEvent.body.content, '#expertJoinUrl', 'JOIN_URL');
    }

    const countryName = availabilityStore.staticData.names.countries[availabilityStore.epl.expert.address.countryId];
    const timezoneName = availabilityStore.staticData.names.timezones[availabilityStore.epl.expert.address.timezoneId];
    const languages = {
      chinese: 'zhTW',
      spanish: 'es',
      russian: 'ru',
      german: 'de',
      french: 'fr',
      italian: 'it',
      korean: 'ko',
      portuguese: 'pt',
      english: 'en',
      polish: 'pl',
      japanese: 'ja'
    };
    let dataToReturn = {};

    if (!!expertEvent) {
      if (!!expertEvent.body && !!expertEvent.body.content && !!expertEvent.body.content.length) {
        dataToReturn.expertInvited = true;
      }

      const extractedExpertEmail = extractExpertEmail(expertEvent);
      const additionaEmails = !!expertEvent.attendees && expertEvent.attendees.slice(2).map(att => att.emailAddress).map(x => {
        const isEmployee = x.name.split('@')[1] === 'atheneum-partners.com';

        if (isEmployee) {
          const name = x.name.split('@')[0].replace(/\./g, ' ');
          return {
            fullName: name,
            email: x.address
          };
        } else {
          return {
            fullName: x.name,
            email: x.address
          };
        }
      });

      if (!!expertEvent.attendees) {
        dataToReturn.additionalEmailsExpert = additionaEmails;
        dataToReturn.numberOfAdditionalExpertEmail = additionaEmails.length;
      }

      const sendTemplateId = extractedExpertEmail.includes('<span type="hidden" id=') ? extractedExpertEmail.split('<span type="hidden" id="')[1].split('"')[0] : false;

      if (!!sendTemplateId && sendTemplateId !== 'null') {
        const prevTemplate = await getEmailTemplate(sendTemplateId);
        dataToReturn.templateId = sendTemplateId;
        dataToReturn.previouslySendLanguage = prevTemplate.name;
      }

      const employeeSubmittedString = await getEmployeeSubmitted(availabilityStore);

      if (extractedExpertEmail.includes(`<p class="employeeSubmitted">`)) {
        const emailBody = extractedExpertEmail.replace(extractedExpertEmail.split(`<p class="employeeSubmitted">`)[1].split('</p>')[0], employeeSubmittedString);
        dataToReturn.expertMessage = emailBody;
        dataToReturn.previouslySend = emailBody;
      } else {
        const split = extractedExpertEmail.split('<p>');
        const eSubmitted = split[split.length - 1].split('</p>')[0];
        const emailBody = extractedExpertEmail.replace(eSubmitted, `<p class="employeeSubmitted">${employeeSubmittedString}</p>`);
        dataToReturn.expertMessage = emailBody;
        dataToReturn.previouslySend = emailBody;
      }

      dataToReturn.showSkipExpert = false;
      dataToReturn.expertSubject = multipleExperts && multipleExperts.length ? formatInvitationSubject(availabilityStore, true) : expertEvent.subject;
      const location = expertEvent && expertEvent.location ? expertEvent.location.displayName : ''; // Default value for zoomLocationExpert

      dataToReturn.zoomLocationExpert = location;

      if (location.includes('{{{meetingId}}}')) {
        const zoomData = await scheduleApi.getZoomNumbers();
        const expertId = getCountryId(zoomData, availabilityStore.epl.expert.address.countryId);
        const getCountryNumberExpert = zoomData.filter(data => data.countryId === expertId);
        const resultExpert = getZoomNumber(getCountryNumberExpert[0]);
        const placeholder = '{{{meetingId}}}';
        dataToReturn.zoomLocationExpert = `Conference call ${resultExpert} //
        ${availabilityStore.schedule.zoomMeetingId ? formatZoomMeetingId(availabilityStore.schedule.zoomMeetingId) : placeholder}`;
      }

      if (expertEvent.body && extractedExpertEmail && !extractedExpertEmail.includes('https://atheneum-partners.zoom.us/') && !extractedExpertEmail.includes('1-Tap')) {
        dataToReturn.meetingType = 'None';
        const theExpert = await getExpert(availabilityStore.epl.expert.id);
        const languagesFiltered = theExpert.languages.filter(lang => templateLanguages.includes(lang.name) && lang.languageToUser.languageProficiencyId === 3).map(d => d.name);
        const language = languagesFiltered.length ? languagesFiltered[0].split(' ')[0] : 'english'; // Default values

        dataToReturn.expertCountry = countryName;
        dataToReturn.expertTimezoneName = timezoneName;
        dataToReturn.selectedLanguage = language.toLowerCase();

        if (language !== 'English') {
          const country = await translate(countryName, languages[language.toLowerCase()]);
          const timezone = await translate(timezoneName, languages[language.toLowerCase()]);
          dataToReturn.expertCountry = country.data.TranslatedText;
          dataToReturn.timezoneTranslated = timezone.data.TranslatedText;
        }

        const {
          templates
        } = await expertEmailTemplate(language.toLowerCase(), availabilityStore.epl.honorarium);
        dataToReturn.renderSpinner = false;
        dataToReturn.templates = templates;
      } else if (expertEvent.body && extractedExpertEmail && !extractedExpertEmail.includes('https://atheneum-partners.zoom.us/') && extractedExpertEmail.includes('1-Tap')) {
        const theExpert = await getExpert(availabilityStore.epl.expert.id);
        const languagesFiltered = theExpert.languages.filter(lang => templateLanguages.includes(lang.name) && lang.languageToUser.languageProficiencyId === 3).map(d => d.name);
        const language = languagesFiltered.length ? languagesFiltered[0].split(' ')[0] : 'english'; // Default values

        dataToReturn.expertCountry = countryName;
        dataToReturn.expertTimezoneName = timezoneName;

        if (language !== 'English') {
          const country = await translate(countryName, languages[language.toLowerCase()]);
          const timezone = await translate(timezoneName, languages[language.toLowerCase()]);
          dataToReturn.expertCountry = country.data.TranslatedText;
          dataToReturn.timezoneTranslated = timezone.data.TranslatedText;
        }

        if (capiProjectType) {
          const scheduleDetail = await getMcKinseyMeeting(availabilityStore.epl.id, availabilityStore.epl.honorarium);

          if (!!scheduleDetail) {
            dataToReturn.renderSpinner = false;
            dataToReturn.templates = scheduleDetail.templates;
            dataToReturn.meetingType = 'mcKinsey';
            dataToReturn.mcKinseyNumbers = scheduleDetail.phoneNubers;
            dataToReturn.selectedTemplate = scheduleDetail.currentTemplate;
            dataToReturn.mcKinseyTemplates = scheduleDetail.templates;
            dataToReturn.mcKinseyMessage = scheduleDetail.expertMessage;
          }
        } else {
          const {
            expertMessage,
            templates
          } = await expertEmailTemplate(language.toLowerCase(), availabilityStore.epl.honorarium);
          dataToReturn.expertMessage = expertMessage;
          dataToReturn.renderSpinner = false;
          dataToReturn.templates = templates;
          dataToReturn.selectedTemplate = templates.filter(template => template.name.toLowerCase().includes(selectedLanguage))[0];
        }
      } else {
        const theExpert = await getExpert(availabilityStore.epl.expert.id);
        const languagesFiltered = theExpert.languages.filter(lang => templateLanguages.includes(lang.name) && lang.languageToUser.languageProficiencyId === 3).map(d => d.name);
        const language = languagesFiltered.length ? languagesFiltered[0].split(' ')[0] : 'english'; // Default value

        dataToReturn.expertCountry = countryName;
        dataToReturn.expertTimezoneName = timezoneName;
        dataToReturn.selectedLanguage = language.toLowerCase();

        if (language !== 'English') {
          const country = await translate(countryName, languages[language.toLowerCase()]);
          const timezone = await translate(timezoneName, languages[language.toLowerCase()]);
          dataToReturn.expertCountry = country.data.TranslatedText;
          dataToReturn.timezoneTranslated = timezone.data.TranslatedText;
        }

        const {
          templates
        } = await expertEmailTemplate(language.toLowerCase(), availabilityStore.epl.honorarium);
        dataToReturn.templates = templates;
        dataToReturn.renderSpinner = false;
      }

      return dataToReturn;
    }

    const theExpert = await getExpert(availabilityStore.epl.expert.id);
    const languagesFiltered = theExpert.languages.filter(lang => templateLanguages.includes(lang.name) && lang.languageToUser.languageProficiencyId === 3).map(d => d.name);
    const language = languagesFiltered.length ? languagesFiltered[0].split(' ')[0] : 'english'; // Default values

    dataToReturn.expertCountry = countryName;
    dataToReturn.expertTimezoneName = timezoneName;

    if (language !== 'English') {
      const country = await translate(countryName, languages[language.toLowerCase()]);
      const timezone = await translate(timezoneName, languages[language.toLowerCase()]);
      dataToReturn.expertCountry = country.data.TranslatedText;
      dataToReturn.timezoneTranslated = timezone.data.TranslatedText;
    }

    const {
      expertMessage,
      templates
    } = await expertEmailTemplate(language.toLowerCase(), availabilityStore.epl.honorarium);
    dataToReturn.expertMessage = expertMessage;
    dataToReturn.renderSpinner = false;
    dataToReturn.templates = templates;
    dataToReturn.selectedTemplate = templates.filter(template => template.name.toLowerCase().includes(selectedLanguage))[0];
    const zoomData = await scheduleApi.getZoomNumbers();
    const expertId = getCountryId(zoomData, availabilityStore.epl.expert.address.countryId);
    const getCountryNumberExpert = zoomData.filter(data => data.countryId === expertId);
    const resultExpert = getZoomNumber(getCountryNumberExpert[0]);
    const placeholder = '{{{meetingId}}}';
    dataToReturn.zoomLocationExpert = `Conference call ${resultExpert} // ${availabilityStore.schedule.zoomMeetingId ? formatZoomMeetingId(availabilityStore.schedule.zoomMeetingId) : placeholder}`;
    return dataToReturn;
  }; // TODO: rewrite this


  const getDataWhenTheresNoSchedule = async () => {
    const theExpert = await getExpert(availabilityStore.epl.expert.id);
    const MC_KINSEY_PARENT_ACCOUNT_ID = 32;
    const countryName = availabilityStore.staticData.names.countries[availabilityStore.epl.expert.address.countryId];
    const timezoneName = availabilityStore.staticData.names.timezones[availabilityStore.epl.expert.address.timezoneId];
    const languages = {
      chinese: 'zhTW',
      spanish: 'es',
      russian: 'ru',
      german: 'de',
      french: 'fr',
      italian: 'it',
      korean: 'ko',
      portuguese: 'pt',
      english: 'en',
      polish: 'pl',
      japanese: 'ja'
    };
    const dataToReturn = {};
    const mcKinseyMeeting = !!capiProjectType && ((await getMcKinseyMeeting(availabilityStore.epl.id, availabilityStore.epl.honorarium)) || project.parentAccountId === MC_KINSEY_PARENT_ACCOUNT_ID);
    const languagesFiltered = theExpert.languages.filter(lang => templateLanguages.includes(lang.name) && lang.languageToUser.languageProficiencyId === 3).map(d => d.name);
    const language = languagesFiltered.length ? languagesFiltered[0].split(' ')[0] : 'english'; // Default value

    dataToReturn.expertCountry = countryName;

    if (language !== 'English' || language !== 'english') {
      const country = await translate(countryName, languages[language.toLowerCase()]);
      const timezone = await translate(timezoneName, languages[language.toLowerCase()]);
      dataToReturn.expertCountry = country.data.TranslatedText;
      dataToReturn.timezoneTranslated = timezone.data.TranslatedText;
    }

    dataToReturn.expertTimezoneName = timezoneName;
    dataToReturn.selectedLanguage = language.toLowerCase();

    if (!!mcKinseyMeeting) {
      dataToReturn.renderSpinner = false;
      dataToReturn.meetingType = 'mcKinsey';
      dataToReturn.mcKinseyNumbers = mcKinseyMeeting.phoneNubers;
      dataToReturn.selectedTemplate = mcKinseyMeeting.currentTemplate;
      dataToReturn.mcKinseyTemplates = mcKinseyMeeting.templates;
      dataToReturn.mcKinseyMessage = mcKinseyMeeting.expertMessage;
      dataToReturn.expertMessage = mcKinseyMeeting.expertMessage;
      dataToReturn.templates = mcKinseyMeeting.templates;
    } else {
      // AP-3576
      const {
        templates,
        expertMessage
      } = await expertEmailTemplate(language.toLowerCase(), availabilityStore.epl.honorarium);
      dataToReturn.expertMessage = expertMessage;
      dataToReturn.renderSpinner = false;
      dataToReturn.templates = templates;
      dataToReturn.selectedTemplate = templates.filter(template => template.name.toLowerCase().includes(selectedLanguage))[0];
    }

    const data = await scheduleApi.getZoomNumbers();
    const {
      countryId: clientCountryId
    } = await getAddressById(project.office.addressId);
    const clientId = getCountryId(data, clientCountryId);
    const expertId = getCountryId(data, availabilityStore.epl.expert.address.countryId);
    const getCountryNumberExpert = data.filter(data => data.countryId === expertId);
    const getCountryNumberClient = data.filter(data => data.countryId === clientId);
    const resultExpert = getZoomNumber(getCountryNumberExpert[0]);
    const resultClient = getZoomNumber(getCountryNumberClient[0]);
    dataToReturn.zoomLocationExpert = `Conference call ${resultExpert} //  {{{meetingId}}}`;
    dataToReturn.zoomLocationClient = `Conference call ${resultClient} //  {{{meetingId}}}`;
    return dataToReturn;
  };

  const pages = {
    sendInviteClient: /*#__PURE__*/React.createElement(SendInviteClient, null),
    sendInviteExpert: /*#__PURE__*/React.createElement(SendInviteExpert, {
      eplModel: eplModel
    }),
    quickEdit: /*#__PURE__*/React.createElement(QuickEdit, null),
    createZoom: /*#__PURE__*/React.createElement(CreateZoom, {
      eplModel: eplModel,
      lastPath: 'calendarview'
    }),
    availabilityForm: /*#__PURE__*/React.createElement(AvailabilityForm, null)
  };
  const uxSwitch = document.querySelector('.switchTarget');

  if (!!uxSwitch) {
    const pageArray = Object.keys(pages);

    if (pageArray.includes(currentPath)) {
      uxSwitch.style.display = 'none';
    } else {
      uxSwitch.style.display = 'flex';
    }
  }

  const renderZoom = currentPath === 'overview' && !!schedule.timeslots.length || currentPath === 'calendarview' && readOnly; // UI starts here

  return /*#__PURE__*/React.createElement(React.Fragment, null, renderSpinner && /*#__PURE__*/React.createElement("div", {
    className: "spinner__modal-container"
  }, /*#__PURE__*/React.createElement(Spinner, null)), currentPath === 'overview' || currentPath === 'calendarview' ? /*#__PURE__*/React.createElement(React.Fragment, null, currentPath === 'overview' && /*#__PURE__*/React.createElement("div", {
    className: "viewContainer"
  }, /*#__PURE__*/React.createElement(Overview, {
    onDeleteTimeslot: onDeleteTimeslot,
    growlStore: growlStore,
    eplModel: eplModel
  })), currentPath === 'calendarview' && /*#__PURE__*/React.createElement("div", {
    id: "calendarContainer",
    className: "wrapper viewContainer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "overview"
  }, /*#__PURE__*/React.createElement(Scheduling, {
    growlStore: growlStore
  }))), renderZoom && /*#__PURE__*/React.createElement(ZoomContainer, {
    multiAction: multiAction,
    multipleExperts: multipleExperts,
    growlStore: growlStore
  }), /*#__PURE__*/React.createElement(RenderPhonenumbers, null), availabilityStore.clientSchedulingRequest && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h2", {
    className: "expert-profile__subtitle schedule-calendar__subtitle"
  }, "Client availability details"), /*#__PURE__*/React.createElement(InfoBox, {
    icon: null
  }, availabilityStore.clientSchedulingRequest || `Client didn't specify any availability details.`)), /*#__PURE__*/React.createElement(Submit, {
    growlStore: growlStore // projectStore={projectStore}
    ,
    eplModel: eplModel,
    handleClose: handleClose,
    sendToCalendarService: sendToCalendarService,
    generateLocationLabel: generateLocationLabel,
    getTimezoneName: getTimezoneName,
    availabilityStore: availabilityStore,
    multipleExperts: multipleExperts,
    addressApi: getAddressById,
    project: project,
    multiAction: multiAction
  })) : /*#__PURE__*/React.createElement("div", {
    id: "calendarContainer",
    className: "wrapper viewContainer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "overview"
  }, pages[currentPath])));
};

function replaceEmailInfoWithPlaceholders(string, targetId, replacementString) {
  var div = document.createElement('div');
  div.innerHTML = string;
  var target = div.querySelector(targetId);

  if (!target) {
    // TODO: add back after a week or so
    // sendMetric('error.replaceEmailInfoWithPlaceholders', 'meeting-invites', {
    //   status: 'failed',
    //   targetId
    // })
    return string;
  }

  target.innerHTML = replacementString;
  return div.innerHTML;
}

function extractExpertEmail(expertEvent) {
  const div = document.createElement('div');
  const id = 'temporaryJoinedEmail';
  div.id = id;
  div.style.display = 'none';

  if (expertEvent && expertEvent.body) {
    div.innerHTML = expertEvent.body.content.replace(/\r\n/g, '');
  }

  document.body.appendChild(div);
  const joinedEmail = document.getElementById('joinedEmail');
  const message = (joinedEmail === null || joinedEmail === void 0 ? void 0 : joinedEmail.innerHTML) || div.innerHTML;
  div.remove();
  return message;
}

export default FasterScheduling;